(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_installation-group"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wv-togglezip-video')) {
 customElements.define('wv-togglezip-video', class extends HTMLElement {
  connectedCallback() {
   if(this.abort)return;
   this.abort=new AbortController();
   this.details=this.querySelector('details');
   this.player=this.querySelector('[data-player]');
   this.media=matchMedia('(max-width:749px)');
   const opts={signal:this.abort.signal};
   this.details.addEventListener('toggle',()=>this.update(),opts);
   this.media.addEventListener('change',()=>this.update(),opts);
   this.observer=new MutationObserver(()=>this.update());
   for(let p=this.parentElement;p;p=p.parentElement)this.observer.observe(p,{attributes:true,attributeFilter:['hidden','style','class']});
   this.update();
  }
  update() {
   if(!this.details.open||this.closest('[hidden]')||!this.getClientRects().length) {
    this.player.replaceChildren();this.activeId=null;return;
   }
   const id=this.media.matches?this.dataset.mobile:this.dataset.desktop;
   if(id===this.activeId)return;
   if(!/^[a-zA-Z0-9_-]{11}$/.test(id))return;
   const frame=document.createElement('iframe');
   frame.title=this.player.title;
   frame.src='https://www.youtube-nocookie.com/embed/'+id+'?playsinline=1&rel=0';
   frame.allow='encrypted-media; picture-in-picture; fullscreen';
   frame.allowFullscreen=true;
   frame.referrerPolicy='strict-origin-when-cross-origin';
   this.player.replaceChildren(frame);this.activeId=id;
  }
  disconnectedCallback() {
   this.player?.replaceChildren();this.observer?.disconnect();this.abort?.abort();this.abort=null;this.activeId=null;
  }
 });
}


if (!customElements.get('wv-snap-video')) {
  customElements.define('wv-snap-video', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.manualPause = false;
      this.internalPauses = 0;
      this.visible = false;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.video.muted = true;
      this.video.loop = true;
      this.video.playsInline = true;
      this.video.controls = true;
      this.video.addEventListener('pause', () => {
        if (this.internalPauses) this.internalPauses--;
        else this.manualPause = true;
      }, options);
      this.video.addEventListener('play', () => {
        this.manualPause = false;
        if (!this.isVisible()) this.pauseVideo();
      }, options);
      this.observer = new IntersectionObserver(() => this.updatePlayback(), { threshold: [0, 0.1] });
      this.observer.observe(this.video);
      this.visibilityObserver = new MutationObserver(() => this.updatePlayback());
      for (let parent = this.parentElement; parent; parent = parent.parentElement) {
        this.visibilityObserver.observe(parent, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
      }
      document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
      this.updatePlayback();
    }
    isVisible() {
      if (document.hidden || this.closest('[hidden]')) return false;
      const rect = this.video.getBoundingClientRect();
      if (!rect.width || !rect.height || getComputedStyle(this.video).visibility === 'hidden') return false;
      const width = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
      const height = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
      return width * height / (rect.width * rect.height) >= 0.1;
    }
    pauseVideo() {
      if (!this.video.paused) {
        this.internalPauses++;
        this.video.pause();
      }
    }
    updatePlayback() {
      const visible = this.isVisible();
      const entering = visible && !this.visible;
      this.visible = visible;
      if (!visible) this.pauseVideo();
      else if (entering && !this.manualPause && !this.reducedMotion.matches) {
        try {
          const playback = this.video.play();
          if (playback && typeof playback.catch === 'function') playback.catch(() => {});
        } catch (error) {
          this.video.controls = true;
        }
      }
    }
    disconnectedCallback() {
      this.pauseVideo();
      this.abort?.abort();
      this.observer?.disconnect();
      this.visibilityObserver?.disconnect();
      this.observer = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
